/**
 * One money formatter for the whole product.
 *
 * Prices are stored as decimals and quoted per week. Whole pounds are shown
 * without the trailing ".00" — "£50" reads as a price, "£50.00" reads as an
 * invoice line — and anything with pence keeps both digits.
 *
 * @param {number|string|null|undefined} amount
 * @param {{currency?: string}} [options]
 * @returns {string} e.g. "£4", "£23.75"
 */
export function formatMoney (amount, options = {}) {
  const value = Number(amount)

  if (!Number.isFinite(value)) {
    return ''
  }

  return new Intl.NumberFormat('en-GB', {
    style: 'currency',
    currency: options.currency ?? 'GBP',
    minimumFractionDigits: Number.isInteger(value) ? 0 : 2,
    maximumFractionDigits: 2,
  }).format(value)
}

/**
 * A price range, collapsed when both ends are the same.
 *
 * @param {number|null} from
 * @param {number|null} to
 * @returns {string}
 */
export function formatMoneyRange (from, to) {
  if (from == null && to == null) {
    return ''
  }

  if (from == null || to == null || Number(from) === Number(to)) {
    return formatMoney(from ?? to)
  }

  return `${formatMoney(from)}–${formatMoney(to)}`
}

export default formatMoney
